import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Routes from './routes';
import Promise from 'bluebird';
import Hotjar from '@hotjar/browser';
import { store } from './store/store';
import { selectAuthUser } from './store/authSlice';
import { identifyLaunchDarklyUser } from './core/launchDarkly';
import gitlabFeatureFlagPollingService from './core/GitlabFeatureFlagPollingService';

Promise.config({
	cancellation: true,
	longStackTraces: false,
	warnings: false
});

const siteId = window.location.origin=='https://dev-view.iq-series.com'?4948609:3741179;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

let previousLaunchDarklyUserKey = null;
const syncLaunchDarklyIdentity = () => {
	const user = selectAuthUser(store.getState());
	const userKey = user?.id ? String(user.id) : null;
	if (previousLaunchDarklyUserKey === userKey) return;
	previousLaunchDarklyUserKey = userKey;
	identifyLaunchDarklyUser(user).catch(() => {
		// Reset so the next store update retries the identify
		previousLaunchDarklyUserKey = null;
	});
};

store.subscribe(syncLaunchDarklyIdentity);
syncLaunchDarklyIdentity();

// GitLab-backed flags are fetched independently of LaunchDarkly. Keep the
// LaunchDarkly identity flow above because existing production flags still use it.
const syncFeatureFlagPolling = () => {
	gitlabFeatureFlagPollingService.syncWithAuth(store.getState().auth);
};

store.subscribe(syncFeatureFlagPolling);
syncFeatureFlagPolling();

ReactDOM.render(<div>
	<StrictMode>
		<Provider store={store}>
			<Routes />
		</Provider>
	</StrictMode>
</div>, document.getElementById('app'));
